// entries and object and put empty string key into first index
export const entriesKeyValue = (obj: any) => {
  let emptyIdx = -1;
  const result = Object.keys(obj).map((key, idx) => {
    if (!key) emptyIdx = idx;
    return [key, obj[key]];
  });

  if (emptyIdx == -1) return result;

  result.splice(0, 0, result.splice(emptyIdx, 1)[0]);

  return result;
};
